import { render, staticRenderFns } from "./studentManagement.vue?vue&type=template&id=fdc7a4e0&scoped=true&"
import script from "./studentManagement.vue?vue&type=script&lang=js&"
export * from "./studentManagement.vue?vue&type=script&lang=js&"
import style0 from "./studentManagement.vue?vue&type=style&index=0&id=fdc7a4e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc7a4e0",
  null
  
)

export default component.exports